import { createI18n } from 'vue-i18n'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationEN from '../../locales/en.json'
import translationNL from '../../locales/nl.json'
import translationDE from '../../locales/de.json'
import translationFR from '../../locales/fr.json'
import translationFY from '../../locales/fy.json'

// Detect language
const languageDetector = new LanguageDetector()
languageDetector.init()
const detectedLanguage = languageDetector.detect() || 'en'

const i18n = createI18n({
  legacy: true, // Use Options API for $t to work in templates
  locale: detectedLanguage,
  fallbackLocale: 'en',
  messages: {
    en: translationEN,
    nl: translationNL,
    de: translationDE,
    fr: translationFR,
    fy: translationFY
  },
  globalInjection: true, // Makes $t available globally
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

export default i18n 